import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { PermissionService } from '../services/permission.service';
import { PermissionEnum } from '@app/generated/graphql';

@Directive({ selector: '[agLineItemEditableField]' })
export class LineItemEditableFieldDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private elseRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private permissionService = inject(PermissionService);

  resourceId: PermissionEnum;
  editable = true;

  constructor() {}

  @Input()
  set agLineItemEditableField(resourceId: PermissionEnum) {
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.resourceId = resourceId;
    this.updateView();
  }

  @Input()
  set agLineItemEditableFieldEditable(value: boolean) {
    this.editable = value;
    this.updateView();
  }

  @Input()
  set agLineItemEditableFieldElse(value: TemplateRef<any>) {
    this.elseRef = value;
    this.updateView();
  }

  async updateView() {
    const hasPermission = await this.permissionService.allow(this.resourceId);
    if (hasPermission && this.editable) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.elseRef);
    }
  }
}
